module.exports = __webpack_public_path__ + "assets/img/user_achievement_l1.78a87180.png";